export enum ActivityStreamEventOperation {
  Created = 'Created',
  Updated = 'Updated',
  Deleted = 'Deleted'
}
